;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import moment from "moment-timezone"

type ConvertTimeInput = {
  time: string
  originalTimezone: string
  returnFormat?: string
}

const convertTimeStampOfTimezoneToLocalTime = ({
  time,
  originalTimezone,
  returnFormat = "h:mmA",
}: ConvertTimeInput): string => {
  const timeFormats = ["h:mm a", "h:mma", "h:mm A", "h:mmA"]

  if (!moment(time, timeFormats, true).isValid()) {
    throw new Error(`Time format should be one of: ${timeFormats.join(", ")}`)
  }

  return moment.tz(time, timeFormats, originalTimezone).local().format(returnFormat)
}

export default convertTimeStampOfTimezoneToLocalTime
